import clsx from "clsx";
import { RMCCrown } from "../svg/GeneralIcons";
import { Loader } from "../loader/Loader";
import { Avatar } from "../Avatar";
import { getValidImageUrl } from "../../utils";

function List({ data, isLoading }) {
  return (
    <div className="px-4 max-h-[61vh] h-full overflow-y-scroll hidden-scrollbar">
      {/* <div className="rounded-full border-2 mb-4 border-dashed border-primary-hmain w-fit px-1 py-3">
        <p className="text-primary-hmain text-center text-[0.5rem] font-bold">
          {" "}
          900/1400
        </p>
      </div> */}
      {isLoading ? (
        <div className="flex justify-center items-center h-[53vh] flex-col gap-3">
          <div className="grid place-self-center h-full">
            <Loader type="spinningBubbles" color="#2741d6" />
          </div>
        </div>
      ) : data?.leaderboard?.length === 0 ? (
        <div className="flex justify-center items-center h-[53vh] flex-col gap-3">
          <p className="tracking-tighter text-2xl font-semibold text-black mx-0 text-center">
            No Leaderboard Data
          </p>
          <p className="text-sm font-medium mt-1 text-black w-full max-w-[300px] text-center">
            Once participants start competing, the leaderboard will show up
            here.
          </p>
        </div>
      ) : (
        data?.leaderboard?.map((x, index) => {
          const currentUserId = data.audience_id;
          const user = x.audience;
          const getDisplayName = () => {
            const firstName = user?.first_name?.trim();
            const lastName = user?.last_name?.trim();
            const hasName = firstName || lastName;

            if (x.audience_id === currentUserId) {
              // Current user
              return hasName
                ? `${firstName || ""} ${lastName || ""}`.trim()
                : "YOU";
            } else {
              // Other users
              return hasName
                ? `${firstName || ""} ${lastName || ""}`.trim()
                : "Anonymous";
            }
          };

          const displayName = getDisplayName();
          return (
            <div
              className={
                currentUserId === x.audience_id
                  ? "flex items-center bg-[#2741D6] rounded-[10px] w-full justify-between border-b my-3 border-neutral-300 px-3 py-4 shadow-sm"
                  : "flex items-center bg-[#FFFFFF] justify-between rounded-[10px] w-full border-b border-neutral-300 my-3 px-3 py-4 shadow-sm"
              }
              key={index}
            >
              <div className="flex items-center gap-2.5 880:gap-4">
                <div className="flex items-center relative">
                  <p
                    className={clsx(
                      currentUserId === x.audience_id ? "text-white" : "",
                      "text-primary-main font-medium"
                    )}
                  >
                    {index + 1 === 1 ? (
                      <RMCCrown
                        fill={
                          index + 1 === 1 && currentUserId === x.audience_id
                            ? "#FFD700"
                            : "#FFD700"
                        }
                      />
                    ) : (
                      index + 1
                    )}
                  </p>
                </div>
                {x.audience.profile_image ? (
                  <div
                    className={clsx(
                      currentUserId === x.audience_id
                        ? "border-gradient_4"
                        : "border-gradient",
                      "p-0.5  rounded-full w-fit cursor-pointer"
                    )}
                  >
                    <img
                      className="w-10 h-10 object-cover rounded-full"
                      src={x.audience.profile_image}
                      alt="Profile_image"
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <Avatar name={displayName} size="sm" className="w-10 h-10" />
                )}
                <div>
                  <p
                    className={
                      currentUserId === x.audience_id
                        ? " font-medium text-base text-white leading-tight"
                        : "font-medium text-base leading-tight text-[#000000]"
                    }
                  >
                    {displayName}
                  </p>
                  <p
                    className={
                      currentUserId === x.audience_id
                        ? "font-semibold text-[10px] text-white leading-tight"
                        : "font-semibold text-[10px]  leading-tight text-[#0000004D]"
                    }
                  >
                    {x.total_score} pts.
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                {user?.audience_badges?.map((y) => {
                  const badgeName = y?.badge?.name;
                  const imageUrl = getValidImageUrl(
                    y?.badge?.image_url,
                    "/image/BronzeMedal.png"
                  );

                  return (
                    <img
                      key={y.id}
                      src={imageUrl}
                      alt={badgeName || "User current badge"}
                      className="w-[18px] h-[23px] object-contain"
                      loading="lazy"
                    />
                  );
                })}
                {/* <Silver />
                <Bronze />
                <Gold />
                {isEven && <BlueMedal />} */}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

export default List;
